import { render } from "./Service.vue?vue&type=template&id=d3fedb78&scoped=true"
import script from "./Service.vue?vue&type=script&lang=js"
export * from "./Service.vue?vue&type=script&lang=js"

import "./Service.vue?vue&type=style&index=0&id=d3fedb78&scoped=true&lang=css"

import exportComponent from "C:\\Users\\ken\\Documents\\GitHub\\KasongNursingHome\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3fedb78"]])

export default __exports__